<template>
    <div>
        <ul class="nav nav-tabs">
            <li :class="{'active' : currentTab === 'return'}">
                <a href="#" @click="setTab('return', $event)">Возврат</a>
            </li>
            <!--<li :class="{'active' : currentTab === 'short_supply'}">-->
                <!--<a href="#" @click="setTab('short_supply', $event)">Недопоставка</a>-->
            <!--</li>-->
            <li :class="{'active' : currentTab === 'history'}">
                <a href="#" @click="setTab('history', $event)">История обращений</a>
            </li>
        </ul>

        <div class="tab-content">
            <div class="tab-pane fade" :class="{'in active' : currentTab === 'return'}">
                <return-component></return-component>
            </div>
            <!--<div class="tab-pane fade" :class="{'in active' : currentTab === 'short_supply'}">-->
                <!--<h1>Что тут должно быть?</h1>-->
            <!--</div>-->
            <div class="tab-pane fade" :class="{'in active' : currentTab === 'history'}">
                <return-history></return-history>
            </div>
        </div>
    </div>
</template>

<script>
  import ReturnList from './Return/ReturnList'
  import ReturnHistory from './Return/ReturnHistory'
  import { mapGetters } from 'vuex'
  import ReturnComponent from './Return/ReturnComponent'

  export default {
    name: 'Return',
    components: {ReturnComponent, ReturnHistory, ReturnList},
    computed: {
      ...mapGetters('return', [
        'currentTab'
      ])
    },
    data () {
      return {
        params: this.application
      }
    },
    methods: {
      setTab (tab, $event) {
        $event.preventDefault()
        this.$store.commit('return/setTab', {tab})
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Personal/Return.vue